import formAddressFieldsMixin from '@phoenix/mixins/formAddressFieldsMixin';

export default {
  mixins: [formAddressFieldsMixin],

  props: {
    steps: {
      type: Array,
      required: true,
    },
    configName: {
      type: String,
      required: true,
    },
  },

  provide() {
    return {
      fieldIsPresent: this.fieldIsPresent,
      isStepEnabled: this.isStepEnabled,
    };
  },

  data() {
    return {
      currentStep: 1,
    };
  },

  computed: {
    hasSteps() {
      return this.steps.length > 0;
    },
  },

  created() {
    this.formConfigName = this.configName;
  },

  methods: {
    changeStep({ step, scrollToNavigation }) {
      if (!this.isStepEnabled(step)) {
        if (this.currentStep < step) {
          step++;
        } else if (this.currentStep > step) {
          step--;
        }
      }

      this.currentStep = step;

      if (scrollToNavigation) {
        this.$refs.formNavigation?.$el.scrollIntoView();
      }
    },

    isStepEnabled(step) {
      step = this.steps.find((s) => s.step === step);

      if (!Object.hasOwn(step, 'enabled')) {
        return true;
      }

      for (const [field, values] of Object.entries(step.enabled)) {
        if (values.includes(this.fields[field].value)) {
          return true;
        }
      }

      return false;
    },
  },
};
